/* ---- infinite products ---- */
class InfiniteProducts extends HTMLElement {
  constructor() {
    (super(),
      (this.sentinel = this.querySelector("[data-infinite-sentinel]")),
      (this.loading = !1),
      (this.observer = null));
  }
  connectedCallback() {
    this.sentinel &&
      ((this.observer = new IntersectionObserver(
        (t) => {
          t[0].isIntersecting && !this.loading && this.loadMore();
        },
        { rootMargin: "400px 0px" },
      )),
      this.observer.observe(this.sentinel));
  }
  disconnectedCallback() {
    this.observer && this.observer.disconnect();
  }
  async loadMore() {
    let t = this.sentinel.dataset.nextUrl,
      e = document.getElementById("product-grid");
    if (t && e) {
      ((this.loading = !0),
        this.sentinel.classList.add("infinite-sentinel--loading"));
      try {
        let i = await fetch(t);
        if (!i.ok) throw Error(`Request failed: ${i.status}`);
        let s = await i.text(),
          n = new DOMParser().parseFromString(s, "text/html"),
          r = n.getElementById("product-grid");
        if (r) {
          let o = r.querySelectorAll(":scope > li");
          o.forEach((t) => e.appendChild(t));
        }
        let a = n.querySelector("[data-infinite-sentinel]"),
          l = a?.dataset.nextUrl;
        l
          ? (this.sentinel.dataset.nextUrl = l)
          : (this.observer.disconnect(), this.sentinel.remove());
      } catch (d) {
        console.error("Infinite load failed:", d);
      } finally {
        ((this.loading = !1),
          this.sentinel?.classList.remove("infinite-sentinel--loading"));
      }
    }
  }
}
customElements.define("infinite-products", InfiniteProducts);
